import { ITimeSource } from '@fe/core';
import { BaseTimeSource } from './base-time-source';
import { LiveTimeSource } from './live-time-source';
import { PlaybackTimeSource } from './playback-time-source';

class SwitchableSource extends BaseTimeSource implements ITimeSource {
    private readonly live = new LiveTimeSource();
    public readonly playback = new PlaybackTimeSource();
    private _current: BaseTimeSource = this.live;

    constructor() {
        super();
        this.switchToLive();
    }

    get currentTime(): number {
        return this._current.currentTime;
    }

    get currentTimeMs(): number {
        return this._current.currentTimeMs;
    }

    private readonly _fire = this.fire.bind(this);

    switchToLive() {
        this.playback.pause();
        this._current = this.live;
        this.playback.off(this._fire);
        this.live.on(this._fire);
        this.fire(this.live.currentTime, true);
    }

    switchToPlayback(now: number) {
        this._current = this.playback;
        this.live.off(this._fire);
        this.playback.on(this._fire);
        this.playback.setNow(now);
        this.fire(this.playback.currentTime, true);
    }
}

export const timeService = new SwitchableSource();
